.main {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	align-items: stretch;
}

.scroll {
	flex: 1;
	&[data-scroll="true"] {
		overflow-x: clip;
		overflow-y: auto;
		min-height: 0;
		overscroll-behavior: none;
		scrollbar-color: var(--color-border) var(--color-surface);
		scrollbar-width: thin;
	}

	&[data-scroll="false"] .row:last-child > td {
		border-bottom: none;
	}
}

.table {
	border-spacing: 0;
	width: 100%;
	table-layout: fixed;

	> thead {
		position: sticky;
		z-index: 10;
		top: 0;
	}

	.cell {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: var(--size-2);

		&:empty::after {
			content: attr(data-empty, "None");
			color: var(--color-text-subtle);
		}
	}

	.row {
		> th,
		> td {
			padding: var(--size-3);
			vertical-align: middle;
			font-weight: inherit;
			text-align: inherit;

			&.checkbox {
				position: relative;
				z-index: 2;
				width: calc(32px + 4px);
				user-select: none;
				text-align: center;
				padding-left: 12px;
			}

			&.leading {
				padding-inline-start: var(--size-4);
			}

			&.tripleDots {
				position: relative;
				z-index: 2;
				width: calc(32px + 8px);
				user-select: none;
				text-align: center;
				padding-left: 0;
			}

			&.clickable {
				width: 0;
				padding: 0;
			}

			&.expander {
				position: relative;
				z-index: 2;
				width: calc(32px + 4px);
				text-align: center;
				padding-inline-start: 0;
			}
		}

		&.detail > td {
			padding-block-start: 0;
			vertical-align: top;
			border-bottom: var(--size-border) solid var(--color-border);
		}

		&.head {
			background-color: var(--color-surface);
			box-shadow: 0 var(--size-border) 0 var(--color-border);
			font-weight: 600;
		}

		&.body {
			position: relative;

			> th,
			> td {
				border-bottom: var(--size-border) solid var(--color-border);
			}

			&:has(> td.clickable:hover, > td.clickable > a:focus-visible) {
				background-color: var(--color-primary-background);
			}

			&[data-expanded="true"] > td {
				border-bottom-color: transparent;
			}

			> .clickable {
				position: relative;
				padding: 0;
				overflow: visible;

				> a {
					display: block;
					position: absolute;
					top: 0;
					bottom: 0;
					width: 100vw;
				}
			}
		}
	}
}

.sort {
	all: unset;
	cursor: revert-layer;
	display: flex;
	align-items: center;
	gap: var(--size-2);
	max-width: 100%;
	border-radius: var(--radius-xs);

	&:focus-visible {
		outline: 2px solid var(--color-border-focus);
		outline-offset: 2px;
	}

	.label {
		min-width: 0;
		overflow-x: clip;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.arrows {
		display: grid;
		flex-shrink: 0;
	}

	.up,
	.down {
		grid-area: 1 / 1;
		color: light-dark(var(--gray-500), var(--gray-600));
		transition: color 0.1s ease;
	}

	&:hover :is(.up, .down) {
		color: light-dark(var(--gray-600), var(--gray-500));
	}

	[aria-sort="ascending"] > & .up,
	[aria-sort="descending"] > & .down {
		color: inherit;
	}
}

.chevron {
	display: inline-flex;

	@media (prefers-reduced-motion: no-preference) {
		transition: rotate 0.2s;
	}

	[aria-expanded="true"] > & {
		rotate: 0.5turn;
	}
}

.footer {
	box-shadow: 0 calc(-1 * var(--size-border)) 0 var(--color-border);
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: var(--size-2);
	font-size: var(--text-caption);

	.left {
		font-weight: 500;
		padding: 0 var(--size-2);
	}
}

.empty {
	text-align: center;
	padding: var(--size-8);
}
